export default __webpack_public_path__ + "static/media/deped@2x.1885f6b9.png";